import { T } from "@/i18n";

export const Footer = ({ lang }) => (
  <footer data-testid="site-footer" className="border-t border-white/10 py-8">
    <div className="mx-auto flex max-w-6xl flex-col items-center gap-2 px-4 text-center sm:px-6">
      <p className="font-display text-sm font-bold uppercase tracking-[0.3em] text-[#FFE500]">
        {T.footer.made[lang]}
      </p>
      <p className={`text-xs text-white/40 ${lang === "kn" ? "font-kn" : ""}`}>
        {T.hero.theme[lang]} · {T.hero.dates[lang]}
      </p>
    </div>
  </footer>
);
